<template>
  <validation-observer ref="validationobserver" v-slot="{ handleSubmit }">
    <b-form @submit.prevent="handleSubmit(salvar)">
      <b-modal
        id="modal-edicao-item-certidao"
        v-model="vis"
        size="lg"
        centered
        header-bg-variant="secondary"
        header-text-variant="light"
        :title="modalTitle"
        @hidden="$emit('fecharModal')"
      >
        <b-overlay :show="anyLoading" rounded>
          <b-row>
            <b-col cols="6">
              <default-form-validation-provider label="Base Legal" v-slot="ds">
                <b-form-select
                  id="baselegal"
                  v-model="itemAnalisado.IdBaseLegal"
                  :options="bases"
                  :state="ds.state"
                  value-field="Id"
                  text-field="descDropdown"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="6">
              <default-form-validation-provider label="Resultado" v-slot="ds">
                <b-form-radio-group
                  id="resultado"
                  v-model="itemAnalisado.Resultado"
                  :options="resultados"
                  :state="ds.state"
                  buttons
                  button-variant="light"
                />
              </default-form-validation-provider>
            </b-col>

            <b-col cols="6">
              <default-form-validation-provider label="Fonte" v-slot="ds">
                <b-form-input
                  id="fonte"
                  v-model="itemAnalisado.Fonte"
                  :state="ds.state"
                />
              </default-form-validation-provider>
            </b-col>

            <b-col cols="6">
              <default-form-validation-provider label="Usuário" rules="">
                <span class="font-italic">{{
                  certidaoOriginal ? itemAnalisado.UsuarioUltAlt : "-"
                }}</span>
              </default-form-validation-provider>
            </b-col>

            <b-col cols="12">
              <span class="d-block text-left pb-1">Detalhamento *</span>

              <rich-text-editor
                @update-value="atualizarValor"
                :initial-content="itemAnalisado.Detalhamento"
              />
              <span
                v-if="inputValido === false"
                class="d-block text-danger text-left pt-1 small"
              >
                Campo obrigatório, por favor preencher.
              </span>
            </b-col>
          </b-row>
        </b-overlay>
        <template v-slot:modal-footer>
          <b-button :disabled="anyLoading" @click="salvar">
            <font-awesome-icon icon="save" class="mr-2" />
            Salvar
          </b-button>
        </template>
      </b-modal>
    </b-form>
  </validation-observer>
</template>

<script lang="ts">
import { Component, Ref, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { PropType } from "vue";
import { UtilsTS } from "@/utilsts";
import { Certidao } from "@/types/interno/certidoes-ugs/certidao";
import { CertidoesAno } from "@/types/interno/certidoes-ugs/certidoes-ano";
import { BaseLegal } from "@/types/interno/certidoes-ugs/base-legal";
import { ValidationObserver } from "vee-validate";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import certidoesUgService from "@/services/interno/certidoesUgService";
import RichTextEditor from "@/components/RichTextEditor.vue";

const CompProps = Vue.extend({
  name: "ModalEdicaoItemDeCertidao",
  components: {
    ValidationObserver,
    DefaultFormValidationProvider,
    RichTextEditor,
  },
  props: {
    certidaoOriginal: {
      type: Object as PropType<Certidao>,
      required: false,
    },
    bases: {
      type: Array as PropType<BaseLegal[]>,
      required: false,
      default: () => [],
    },
    infoAno: {
      type: Object as PropType<CertidoesAno>,
      required: false,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
});

@Component
export default class ModalEdicaoItemDeCertidao extends mixins(
  UtilsTS,
  CompProps
) {
  @Ref("validationobserver") validationobserver: InstanceType<
    typeof ValidationObserver
  >;

  itemAnalisado: Certidao = new Certidao({ Resultado: true });
  inputValido = false;
  resultados = [
    { value: true, text: "Cumpriu" },
    { value: false, text: "Não cumpriu" },
  ];
  loadingSalvar = false;
  vis = true;

  mounted() {
    if (this.certidaoOriginal) {
      this.itemAnalisado = new Certidao(this.certidaoOriginal);
      this.inputValido = true;
    }
  }

  get anyLoading(): boolean {
    return this.loading || this.loadingSalvar;
  }
  get modalTitle(): string {
    return this.certidaoOriginal ? "Editar item" : "Adicionar item";
  }

  atualizarValor(value) {
    if (value === "") {
      this.inputValido = false;
    } else {
      this.inputValido = true;
    }
    this.itemAnalisado.Detalhamento = value;
  }

  async salvar(): Promise<void> {
    try {
      this.loadingSalvar = true;
      //await new Promise((r) => setTimeout(r, 10000));
      //return;
      const isValid = await this.validationobserver.validate();
      if (!isValid || this.inputValido === false) {
        return;
      }
      if (this.certidaoOriginal) {
        const response = await certidoesUgService.editarItem(
          this.itemAnalisado,
          this.itemAnalisado.Id
        );
        if (response) {
          this.$emit("salvou", "e", response);
        } else {
          this.tratarError(new Error("Falha ao salvar item de certidão"));
        }
      } else {
        const response = await certidoesUgService.salvarItem(
          this.itemAnalisado,
          this.infoAno?.codUG || "",
          this.infoAno?.Exercicio || 0
        );
        if (response) {
          this.$emit("salvou", "c", response);
        } else {
          this.tratarError(new Error("Falha ao salvar item de certidão"));
        }
      }
    } catch (e: unknown) {
      this.tratarError(e);
    } finally {
      this.loadingSalvar = false;
    }
  }
}
</script>
